import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSupplierData } from "../../../../Redux/Selectors/appConfigSelector";
import { getProducsQuoteRequest } from "../../../QuotePage/redux/QuoteActions";
import { getBundlesData } from "../../../QuotePage/redux/QuoteSelectors";
import { useNavigate } from "react-router-dom";

const BundleContainerHome = ({ children }) => {
  const dispatch = useDispatch();
  const supplier = useSelector(getSupplierData);
  const bundles = useSelector(getBundlesData);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(
      getProducsQuoteRequest({
        active: true,
        owner: supplier._id,
      })
    );
  }, []);

  const handleOnClick = (category, selectedBundle = "") => {
    navigate(`/quote?&bundle=${selectedBundle._id}`);
  };

  return children({
    bundles,
    handleOnClick,
  });
};

export default BundleContainerHome;
